import { CommentSharp, NotificationsSharp } from '@mui/icons-material';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const referralTeamSales = {
    id: 'notification',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'notification',
            title: 'Notification',
            type: 'item',
            url: '/notification',
            icon: NotificationsSharp,
            breadcrumbs: false
        }
    ]
};

export default referralTeamSales;
